document.addEventListener('alpine:init', () => {
  Alpine.data('xAccordionNav', () => ({
    items: [],
    isSticky: false,
    stickyTop: 0,
    navHeight: 0,
    activeId: null,

    init() {
      (window.NAAccordionItems || []).forEach(item => {
        this.items.push({ id: item.id, title: item.title });
      });

      document.addEventListener('flex-accordion:register', (e) => {
        if (!this.items.find(i => i.id === e.detail.id)) {
          this.items.push({ id: e.detail.id, title: e.detail.title });
        }
      });

      // Clicking section title: same behavior as clicking nav button
      document.addEventListener('flex-accordion:open', (e) => {
        this._scrollTo(e.detail.id, false);
      });

      this.$watch('activeId', (newId) => {
        if (!newId || !this.$refs.navInner) return;

        this.$nextTick(() => {
          const nav = this.$refs.navInner;
          const btn = nav.querySelector(`[data-acc-id="${newId}"]`);

          if (!btn) return;

          const targetLeft = btn.offsetLeft - nav.offsetWidth / 2 + btn.offsetWidth / 2;
          nav.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        });
      });

      this.$nextTick(() => {
        this.navHeight = this.$refs.navEl?.offsetHeight || 0;

        this.initSticky();
        this.initActiveTracking();
      });
    },

    getHeaderBottom() {
      const el = document.querySelector('.section-header')
        || document.querySelector('#x-header-container')
        || document.querySelector('.shopify-section-header-sticky header');

      if (!el) return 0;
      return Math.max(0, Math.round(el.getBoundingClientRect().bottom));
    },

    getHeaderHeight() {
      const el = document.querySelector('.section-header')
        || document.querySelector('#x-header-container');
      if (!el) return 0;

      const rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.bottom < window.innerHeight * 0.5) {
        return Math.round(rect.bottom);
      }
      
      // Header is hidden (on-scroll-up type scrolled away) — compute from element size
      const announcementH = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')
      ) || 0;

      return Math.round(announcementH + el.offsetHeight);
    },

    _computeFinalPos(targetEl, wrapperEl) {
      const targetAbsPos = targetEl.getBoundingClientRect().top + window.scrollY;
      const details = wrapperEl.querySelector('details');
      const groupName = details?.getAttribute('name');

      if (!groupName) return targetAbsPos;

      let collapsingHeight = 0;
      document.querySelectorAll(`details[name="${CSS.escape(groupName)}"]`).forEach(det => {
        const peer = det.closest('.flex-acc-wrapper');
        if (!peer || peer === wrapperEl) return;

        if ((peer.getBoundingClientRect().top + window.scrollY) >= targetAbsPos) return;

        const content = det.nextElementSibling;
        if (content && content.offsetHeight > 0) {
          collapsingHeight += content.offsetHeight;
        }
      });

      return targetAbsPos - collapsingHeight;
    },

    initSticky() {
      const onScroll = () => {
        const headerBottom = this.getHeaderBottom();
        const navBottom = this.$el.getBoundingClientRect().bottom;

        if (navBottom <= headerBottom) {
          if (!this.isSticky) {
            this.navHeight = this.$refs.navEl?.offsetHeight || 0;
            this.isSticky = true;
          }
          this.stickyTop = headerBottom;
        } else {
          this.isSticky = false;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    },

    initActiveTracking() {
      const onScroll = () => {
        if (this._blockTracking) return;

        const headerBottom = this.getHeaderBottom();
        const navHeight = this.isSticky ? (this.$refs.navEl?.offsetHeight || 0) : 0;
        const triggerLine = headerBottom + navHeight + 20;

        let active = null;
        for (const item of this.items) {
          const el = document.getElementById(item.id);

          if (!el) continue;

          if (el.getBoundingClientRect().top <= triggerLine) {
            active = item.id;
          }
        }
        this.activeId = active;
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    },

    _scrollTo(id, openDetails = true) {
      this.activeId = id;
      this._blockTracking = true;

      clearTimeout(this._blockTrackingTimer);
      this._blockTrackingTimer = setTimeout(() => { this._blockTracking = false; }, 900);

      history.pushState(null, '', '#' + id);

      const el = document.getElementById(id);

      if (el && openDetails) {
        const details = el.querySelector('details');

        if (details && !details.open) details.open = true;
      }

      this.$nextTick(() => {
        if (!el) return;

        requestAnimationFrame(() => {
          const targetEl = el.querySelector('details > summary') || el;

          const finalAbsPos = this._computeFinalPos(targetEl, el);
          const scrollingUp = finalAbsPos < window.scrollY;

          let offset;
          if (this.isSticky && this.$refs.navEl) {
            if (scrollingUp) {
              offset = this.getHeaderHeight() + this.$refs.navEl.offsetHeight + 8;
            } else {
              offset = Math.round(this.$refs.navEl.getBoundingClientRect().bottom) + 8;
            }
          } else {
            const headerBottom = this.getHeaderBottom();
            const navH = this.$refs.navEl?.offsetHeight || 0;
            offset = headerBottom + navH + 8;
          }

          window.scrollTo({
            top: finalAbsPos - offset,
            behavior: 'smooth'
          });
        });
      });
    },

    goTo(id) {
      this._scrollTo(id, true);
    }
  }));
});
